import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from "@auth0/auth0-react";
import {ChakraProvider,theme} from "@chakra-ui/react"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Auth0Provider
    domain="authforproject.us.auth0.com"
    clientId="XvvjfNaNB1IiQ2UPkd11CoFRYyEOS8M4"
    redirectUri={window.location.origin}
  >
  
  
  <ChakraProvider theme={theme}>
  
  <App />
  </ChakraProvider>
  </Auth0Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

export const server = `https://api.coingecko.com/api/v3`;